import {
    UpsertWeightLog,
    WeightLogRequest,
    WeightLogResponse,
} from '@/shared/interfaces/api/sundvaegt-interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const upsertNnWeightLog = async (weightLogRequest: UpsertWeightLog) => {
    return await fetchIStatus<WeightLogResponse, UpsertWeightLog>(
        '/api/nnsundvaegt/log',
        'PUT',
        weightLogRequest,
    );
};
